<template>
  <div
    class="mdt-edit-button flex-center-h"
    :class="{ active: editable }">
    <div
      v-if="editable && save"
      :id="`save-section-${id}`"
      class="btn btn-primary btn-size-32 save-button"
      :data-test="testKey && `save-${camelToKebabCase(testKey)}`"
      @click="$emit('save')">
      {{ 'general_save' | translate }}
    </div>
    <div
      :id="`${editable ? 'cancel-section' : 'edit-section'}-${id}`"
      class="flex-center pointer no-userselect edit-button"
      :class="[`theme-${theme}`, { disabled }]"
      :data-test="`${editable ? 'cancel' : 'edit'}-${camelToKebabCase(testKey)}`"
      @click="$emit('edit')">
      <i :class="editable ? cancelIcon : editIcon" />
    </div>
  </div>
</template>

<script>
import { helpers } from '@/utility';

export default {
  name: 'MdtEditButton',
  props: {
    editable: {
      type: Boolean,
      default: false,
    },
    save: {
      type: Boolean,
      default: false,
    },
    editIcon: {
      type: String,
      default: 'fas fa-pen',
    },
    cancelIcon: {
      type: String,
      default: 'fas fa-times',
    },
    theme: {
      type: String,
      default: 'light',
      validator: (value) => {
        const match = ['default', 'light'];
        return match.includes(value);
      },
    },
    id: {
      type: [String, Number],
      default: () => helpers.generateUniqueId(),
    },
    testKey: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.mdt-edit-button {
  &.active .edit-button {
    color: $color-white;
  }

  .save-button {
    margin-right: 5px;
  }

  .edit-button {
    width: 32px;
    height: 32px;
    border-radius: 50%;

    &.disabled {
      pointer-events: none;
      opacity: 0.3;
    }

    &.theme-default {
      background-color: $color-theme;
      color: $color-white;
      @include button-hover($color-theme-rgb, 0.75);
    }

    &.theme-light {
      background-color: rgba($color-text-secondary-rgb, 0.1);
      color: $color-text-secondary;
      @include button-hover($color-text-secondary, 0.2);

      &:hover {
        color: $color-text-primary;
      }
    }

    i {
      font-size: 14px;
    }
  }
}
</style>
